// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2Nj3I","title":"BackImages_title__2naFA","images":"BackImages_images__2k5RY"};